import styled from "@emotion/styled";
import Download from "@mui/icons-material/Download";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

const Button = styled(Avatar)`
  cursor: pointer;
`;

export default function UnpublishButton({ onClick }) {
  return (
    <Tooltip title="Unpublish">
      <Button sx={{ m: 1, bgcolor: "secondary.main" }} onClick={onClick}>
        <Download />
      </Button>
    </Tooltip>
  );
}
